import { render } from "./Alert.vue?vue&type=template&id=9a297e2c&scoped=true"
import script from "./Alert.js?vue&type=script&lang=js"
export * from "./Alert.js?vue&type=script&lang=js"

import "./Alert.scss?vue&type=style&index=0&id=9a297e2c&scoped=true&lang=scss"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9a297e2c"]])

export default __exports__